module.exports = __webpack_public_path__ + "static/shipkoo-express-5-e52eff9b7b57ea2756cc329e5941e489.png";